import { C } from './colors';

export const OPP_EMOJI = { exhibition: '🏛️', grant: '💰', residency: '🌿' };
export const OPP_COLOR = { exhibition: '#d4c5a9', grant: '#b5c9b8', residency: '#c8d4c0' };

export const TYPE_STYLE = {
  exhibition:{ bg:C.typeExhibition, color:C.typeExhibitionText, label:"Exhibition" },
  grant:     { bg:C.typeGrant,      color:C.typeGrantText,      label:"Grant"      },
  residency: { bg:C.typeResidency,  color:C.typeResidencyText,  label:"Residency"  },
};
